import { MapProps } from '@/features/orders/components/MapPanel/parts/Content/parts/Map/types'
import { useLatestValueRef } from '@/hooks/useLatestValueRef'
import type mapboxgl from 'mapbox-gl'
import { useEffect, useRef } from 'react'

export const useOnDidFinishLoadingMap = (
    map: mapboxgl.Map | undefined,
    layersReady: boolean,
    onLoad: MapProps['onLoad']
) => {
    const latestOnLoad = useLatestValueRef(onLoad)
    const loadedMap = useRef<mapboxgl.Map | undefined>(undefined)

    useEffect(() => {
        if (!map || !layersReady || loadedMap.current === map) return

        loadedMap.current = map
        latestOnLoad.current()
    }, [latestOnLoad, layersReady, map])
}
